import React from 'react';
import { CodeBar } from 'vivace-fluent-motion';
import IntlMessage from "../../../../../helpers/intlMessage";

import Td from './Td';

function Table ({ item }) {
  return (
    <table style={{ width: '100%', marginBottom: '7px' }}>
      <tbody>
        <tr>
          <Td colSpan='2' styleTd={{ padding: '0px 12px', width: '48%' }}>
            <CodeBar
              value={item.nrBloco}
              width={1}
              margin={5}
              height={20}
              fontSize={12}
              lineColor={'#333'}
            />
          </Td>
          <Td colSpan='4' title={<IntlMessage id = "dashboards.taskControl.macroscopist"/>} value={item.macroscopista} />
        </tr>
        <tr>
          <Td
            title={<IntlMessage id = "dashboards.taskControl.material"/>}
            value={item.material}
            styleTd={{ width: '48px' }}
          />
          <Td
            title={<IntlMessage id = "dashboards.reports.typeCassete"/>}
            value={item.tipoCassete}
            styleTd={{ width: '48px' }}
          />
          <Td
            title={<IntlMessage id = "dashboards.reports.fragments"/>}
            value={item.numeroFragmentos}
            styleTd={{ width: '48px' }}
          />
          <Td
            title={<IntlMessage id = "dashboards.taskControl.coloring"/>}
            value={item.coloracao}
            styleTd={{ width: '48px' }}
          />
          <Td
            title={<IntlMessage id = "dashboards.taskControl.urgency"/>}
            value={item.urgencia}
            styleTd={{ width: '48px' }}
          />
          <Td title='NC' value={item.novosCortes} styleTd={{ width: '48px' }} />
        </tr>
      </tbody>
    </table>
  );
}

export default Table;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Recptaculos/Impressao/Table/index.js